import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome-four',
  templateUrl: './welcome-four.component.html',
  styleUrls: ['./welcome-four.component.css']
})
export class WelcomeFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
